import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import config from './../config/config';

const ASST_URL = `${config.asstURL}`;

i18n
  .use(Backend)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    backend: {
      loadPath: `${config.root?config.root:''}/locales/{{lng}}.json`
      },
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });

export default i18n;
